import React, { useEffect, useState } from 'react';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [imageSaving, setImageSaving] = useState(false); // Spinner state


  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    const email = user?.email;

    if (!token || !email) {
      setProfile(null);
      setLoading(false);
      return;
    }

  fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/profile?email=${encodeURIComponent(email)}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        setProfile(data);
        setForm({
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          email: data.email || '',
          username: data.username || '',
          zipcode: data.zipcode || '',
        });
        setLoading(false);
      })
      .catch(() => {
        setProfile(null);
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const allowedTypes = ['image/jpeg', 'image/jpg', 'image/gif'];
  //     if (!allowedTypes.includes(file.type)) {
  //       alert('Only JPG and GIF images are allowed.');
  //       setImageFile(null);
  //       setPreviewUrl('');
  //       return;
  //     }
  //     setImageFile(file);
  //     setPreviewUrl(URL.createObjectURL(file));
  //   } else {
  //     setImageFile(null);
  //     setPreviewUrl('');
  //   }
  // };

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    setIsEditing(false);
    setForm({
      firstName: profile.firstName || '',
      lastName: profile.lastName || '',
      email: profile.email || '',
      username: profile.username || '',
      zipcode: profile.zipcode || '',
    });
    // setImageFile(null);
    // setPreviewUrl('');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
     // let imageUrl = profile.image_url;
      // if (imageFile) {
      //   setImageSaving(true); // Show spinner

      //   // Get the file path from the image file
      //   const filePath = imageFile.webkitRelativePath || imageFile.name || '';
      //   console.log('Selected file path:', filePath);

      //   const formData = new FormData();
      //   formData.append('email', profile.email);
      //   formData.append('imageUrl', filePath); // Pass the file path to backend
      //   formData.append('file', imageFile);    // Pass the actual file for upload

      //   const uploadRes = await fetch('http://localhost:4001/profile/upload-image', {
      //     method: 'POST',
      //       headers: {
      //     'Content-Type': 'application/json',
      //   },
      //      body: JSON.stringify({ ...formData}),
      //   });
      //   const uploadData = await uploadRes.json();
      //   setImageSaving(false); // Hide spinner
      //   if (!uploadRes.ok) {
      //     alert(uploadData.message || 'Image upload failed.');
      //     return;
      //   }
      //   if (uploadData.imageUrl) {
      //     imageUrl = uploadData.imageUrl;
      //   }
      // }

  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/profile/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...form }),
      });
      const data = await res.json();
      if (res.ok) {
        setProfile(data);
        setIsEditing(false);
        setImageFile(null);
        setPreviewUrl('');
        localStorage.setItem('user', JSON.stringify(data));
      } else {
        alert(data.message || 'Error updating profile.');
      }
    } catch {
      setImageSaving(false); // Hide spinner on error
      alert('Error updating profile.');
    }
  };

  if (loading) return <div style={styles.container}>Loading profile...</div>;
  if (!profile) return <div style={styles.container}>No profile data available.</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Profile</h2>
      <div style={styles.card}>
        {/* <div style={styles.imageContainer}>
          {isEditing ? (
            <>
              <input
                type="file"
                accept=".jpg,.jpeg,.gif"
                onChange={handleImageChange}
                style={{ marginBottom: '12px' }}
              />
              {imageSaving && (
                <div style={styles.spinnerBox}>
                  <div className="spinner" style={styles.spinner}></div>
                  <span style={styles.spinnerText}>Saving image...</span>
                </div>
              )}
              {previewUrl ? (
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={styles.profileImage}
                />
              ) : profile.image_url ? (
                <img
                  src={`http://localhost:4001/profile/image?email=${profile.email}`}
                  alt="Profile"
                  style={styles.profileImage}
                />
              ) : (
                <FaUser style={styles.icon} />
              )}
            </>
          ) : profile.image_url ? (
            <img
              src={`http://localhost:4001/profile/image?email=${profile.email}`}
              alt="Profile"
              style={styles.profileImage}
            />
          ) : (
            <FaUser style={styles.icon} />
          )}
        </div> */}
        <form onSubmit={handleSave}>
          <p>
            <strong>First Name:</strong>{' '}
            {isEditing ? (
              <input
                style={styles.input}
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
              />
            ) : (
              profile.firstName
            )}
          </p>
          <p>
            <strong>Last Name:</strong>{' '}
            {isEditing ? (
              <input
                style={styles.input}
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
              />
            ) : (
              profile.lastName
            )}
          </p>
          <p>
            <strong>Email:</strong>{' '}
            {isEditing ? (
              <input
                style={styles.input}
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            ) : (
              profile.email
            )}
          </p>
          <p>
            <strong>Username:</strong>{' '}
            {isEditing ? (
              <input
                style={styles.input}
                name="username"
                value={form.username}
                onChange={handleChange}
                disabled
              />
            ) : (
              profile.username || ''
            )}
          </p>
          <p>
            <strong>Zip Code:</strong>{' '}
            {isEditing ? (
              <input
                style={styles.input}
                name="zipcode"
                value={form.zipcode}
                onChange={handleChange}
              />
            ) : (
              profile.zipcode || ''
            )}
          </p>
          {isEditing ? (
            <div>
              <button style={styles.button} type="submit">Save</button>
              <button style={{ ...styles.button, background: '#888', marginLeft: '10px' }} type="button" onClick={handleCancel}>Cancel</button>
            </div>
          ) : (
            <button style={styles.button} type="button" onClick={handleEdit}>Edit</button>
          )}
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '500px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  title: {
    marginBottom: '24px',
    color: '#4078c0',
    fontSize: '1.5rem',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '24px',
    marginTop: '16px',
    textAlign: 'left',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '18px',
  },
  profileImage: {
    width: '90px',
    height: '90px',
    borderRadius: '50%',
    objectFit: 'cover',
    boxShadow: '0 2px 8px #e0cfa0',
    border: '2px solid #fffde4',
    background: '#f5f6fa',
  },
  icon: {
    fontSize: '4rem',
    color: '#ccc',
    background: '#f5f6fa',
    borderRadius: '50%',
    padding: '12px',
    boxShadow: '0 2px 8px #e0cfa0',
  },
  input: {
    padding: '6px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginLeft: '8px',
  },
  button: {
    padding: '8px 16px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
    marginTop: '12px',
  },
  spinnerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '12px',
  },
  spinner: {
    width: '28px',
    height: '28px',
    border: '4px solid #4078c0',
    borderTop: '4px solid #fff',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '10px',
  },
  spinnerText: {
    color: '#4078c0',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
};

export default Profile;

/*
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
*/